<div class="trailer-cont">
    <iframe class="video-trailer"  src='https://www.youtube.com/embed/{{this}}'
    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>